/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import win from '../../../shared/win';

export const defaultState = {
  showFormNameModal: false,
  plan: win.PLAN,
  isPremium: false,
  vm: {
    missing_credentials: [],
    showNag: false,
    fields: ['paypal', 'stripe', 'flutterwave', 'paystack'],
    authorizePaymentNag: false,
  },
  stripe_credentials: null,
  flutterwave_credentials: null,
  paystack_credentials: null,
  paypal_credentials: null,
  paymentCrendtialModal: false,
  disableHandler: false,
  optionsError: '',
  newFormId: null,
  requiredModal: false,
  confirmClearPremium: false,
};

const formValidationSlice = createSlice({
  name: 'formValidations',
  initialState: defaultState,
  reducers: {
    checkUserVm: (state, action) => {
      return {
        ...state,
        vm: {
          ...state.vm,
          ...action.payload,
        },
      };
    },
    updateCredential: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    externalSave: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    showFormError: (state, action) => {
      const { formError } = action.payload;
      state.formError = formError;
    },
    disableHandler: (state) => {
      state.disableHandler = true;
    },
    saveAction: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    paymentCredntialMissingModal: (state, action) => {
      state.paymentCrendtialModal = action.payload;
    },
    showClearPremiumModal: (state, action) => {
      state.confirmClearPremium = false;
    },
    updatePlan: (state, action) => {
      state.plan = action.payload;
    },
    doShowFormNameModal: (state, action) => {
      state.showFormNameModal = action.payload;
    },
    checkPaymentCredentials: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

const { reducer } = formValidationSlice;
export default reducer;

export const {
  checkUserVm,
  externalSave,
  showFormError,
  disableHandler,
  updateCredential,
  showClearPremiumModal,
  saveAction,
  updatePlan,
  paymentCredntialMissingModal,
  doShowFormNameModal,
  checkPaymentCredentials,
} = formValidationSlice.actions;
